import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";
import {environment} from "../../../environments/environment";
import {SessionManagerService} from "../../services/session-manager.service";
import {ChannelConfig, ChannelDefinition} from "../../model/channels.model";
import {ObjectMapper} from "json-object-mapper";
import {ViewManagerService} from "../../services/view-manager.service";

@Injectable({
  providedIn: 'root'
})
export class ChannelsService {

  constructor(
    private http: HttpClient,
    private viewManager: ViewManagerService,
    private sessionManager: SessionManagerService
  ) {
  }

  all() {
    let path = "/channels/" + this.sessionManager.session?.space
    return this.http.get<ChannelConfig[]>(environment.apiPrefix + path)
  }

  list(vertical: String) {
    let path = "/channels/" + this.sessionManager.session?.space + "/" + vertical
    return this.http.get<ChannelConfig[]>(environment.apiPrefix + path)
  }

  functionality(vertical: String, frontend: String) {
    let path = "/channels/" + this.sessionManager.session?.space + "/" + vertical + "/" + frontend
    return this.http.get<ChannelConfig[]>(environment.apiPrefix + path)
  }

  view(owner: string, vertical: string, code: string) {
    let path = "/channel/" + owner + "/" + vertical + "/" + code
    return this.http.get<ChannelDefinition>(environment.apiPrefix + path)
      .pipe(
        map(response => {
          return ObjectMapper.deserialize(ChannelDefinition, response);
        })
      );
  }

}
